import { render, staticRenderFns } from "./registerAfter.vue?vue&type=template&id=38adc606&scoped=true&"
import script from "./registerAfter.vue?vue&type=script&lang=js&"
export * from "./registerAfter.vue?vue&type=script&lang=js&"
import style0 from "./registerAfter.vue?vue&type=style&index=0&id=38adc606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38adc606",
  null
  
)

export default component.exports